/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementShowGroupInfoResponse } from "./GroupManagementShowGroupInfoResponse";

export type GroupManagementShowGroupInfoResponseApiRespoonse = {
  data?: GroupManagementShowGroupInfoResponse;
  status?: GroupManagementShowGroupInfoResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementShowGroupInfoResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
